import { render } from "./decreasingContrast.vue?vue&type=template&id=5070827a&scoped=true"
import script from "./decreasingContrast.vue?vue&type=script&lang=js"
export * from "./decreasingContrast.vue?vue&type=script&lang=js"

import "./decreasingContrast.vue?vue&type=style&index=0&id=5070827a&scoped=true&lang=css"
import "./decreasingContrast.vue?vue&type=style&index=1&id=5070827a&lang=css"

import exportComponent from "E:\\Work\\GPTWeb\\licCode\\lic\\webviewer\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5070827a"]])

export default __exports__